export default "__VITE_ASSET__CcHpTt20__"